import React from 'react';
import '../less/index.less'
import hero_img from '../img/hero_img.png';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsNew from '../../../../../auxiliary-components/shared/QuestionsNew';
import hero_data from '../enums/hero_data.json';
import { safeBoxesTariffsLink } from '../../../../../services/urls/urls';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import storeBlockItems from '../enums/store_block_items.json';
import accessBlockItems from '../enums/access_block_items.json';
import sizeBlockItems from '../enums/size_block_items.json';
import branches_icon from '../img/branches_icon.svg';
import { ReactSVG } from 'react-svg';
import { getSafeLinkProps } from '../../../../../helpers/utils/urlSecurity';

export default function template() {
  const page = 'safe-boxes';

  const handlersMap = {
    safeBoxesTariffsLink: safeBoxesTariffsLink,
  };

  const imagesMap = {
    advantages_img_1,
    advantages_img_2,
    advantages_img_3,
    advantages_img_4
  };
  
  const heroData = {
    ...hero_data,
    link: {
      ...hero_data.link,
      href: handlersMap[hero_data.link.href],
    },
  };

  const advantagesItems = advantagesItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const renderInfoBlock = (blockName, titleKey, items, subtitleKey = null) => (
    <div className={`${blockName}-block`}>
      <div className="container">
        <h2 className={`${blockName}-block__title`}>{this.l10n(titleKey)}</h2>
        {subtitleKey && <div className={`${blockName}-block__subtitle`}>{this.l10n(subtitleKey)}</div>}
        <div className={`${blockName}-block__body`}>
          {items.map((item, index) => (
            <div key={index} className={`${blockName}-block__item item-${blockName}-block`}>
              <div className={`item-${blockName}-block__title`}>{this.l10n(item.title)}</div>
              <div className={`item-${blockName}-block__text`}>{this.l10n(item.text)}</div>
            </div>
          ))}
        </div>
        {blockName === 'size' && (
          <div className={`${blockName}-block__btns`}>
            <a className={`${blockName}-block__btn`} {...getSafeLinkProps(safeBoxesTariffsLink, {target: '_blank'})}>
              {this.l10n('SAFE_BOXES_NEW_SIZE_BLOCK_BTN_1')}
            </a>
            <a className={`${blockName}-block__btn ${blockName}-block__btn_white`} {...getSafeLinkProps("branches", {target: '_self', navigate: this.navigate})}>
              <ReactSVG src={branches_icon} className={`${blockName}-block__btn-icon`}/>
              {this.l10n('SAFE_BOXES_NEW_SIZE_BLOCK_BTN_2')}
            </a>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className="module-safe-boxes">
      <Hero
        data={heroData}
        img={hero_img}
        page={page}
      />
      <div className="content">
        <>
          <Advantages
            items={advantagesItems}
            title={'SAFE_BOXES_NEW_ADVANTAGES_TITLE'}
          />
          {renderInfoBlock('store', 'SAFE_BOXES_NEW_STORE_BLOCK_TITLE', storeBlockItems)}
          {renderInfoBlock('size', 'SAFE_BOXES_NEW_SIZE_BLOCK_TITLE', sizeBlockItems, 'SAFE_BOXES_NEW_SIZE_BLOCK_SUBTITLE')}
          {renderInfoBlock('access', 'SAFE_BOXES_NEW_ACCESS_BLOCK_TITLE', accessBlockItems)}
        </>
      </div>
    </div>
  );
}
